import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import QuickActionButton from '../../components/ui/QuickActionButton';
import AnalyticsHeader from './components/AnalyticsHeader';
import KPICards from './components/KPICards';
import CostTrendChart from './components/CostTrendChart';
import BrandPerformanceChart from './components/BrandPerformanceChart';
import CostDistributionChart from './components/CostDistributionChart';
import MultiStoreComparison from './components/MultiStoreComparison';
import DetailedAnalyticsTable from './components/DetailedAnalyticsTable';

const BrandAnalytics = () => {
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    timeRange: 'last3months',
    brand: 'all',
    store: 'all',
    brandingType: 'all'
  });

  // Add mock data state
  const [data, setData] = useState({
    kpi: {
      totalCost: 125000,
      totalBrands: 45,
      avgCostPerBrand: 2778,
      costIncrease: 12.5
    },
    costTrend: [],
    brandPerformance: [],
    costDistribution: [],
    multiStore: [],
    detailedAnalytics: []
  });

  // Simulate data loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      // Simulate loading data
      setData({
        kpi: {
          totalCost: 125000,
          totalBrands: 45,
          avgCostPerBrand: 2778,
          costIncrease: 12.5
        },
        costTrend: [
          { month: 'Jan', cost: 10000 },
          { month: 'Feb', cost: 12000 },
          { month: 'Mar', cost: 11500 }
        ],
        brandPerformance: [
          { brand: 'Brand A', performance: 85 },
          { brand: 'Brand B', performance: 92 }
        ],
        costDistribution: [
          { category: 'Digital', value: 60000 },
          { category: 'Print', value: 40000 }
        ],
        multiStore: [
          { store: 'Store 1', cost: 30000 },
          { store: 'Store 2', cost: 25000 }
        ],
        detailedAnalytics: [
          { id: 1, brand: 'Brand A', cost: 15000, performance: 85 },
          { id: 2, brand: 'Brand B', cost: 18000, performance: 92 }
        ]
      });
    }, 1500);

    return () => clearTimeout(timer);
  }, [filters]);

  const handleFilterChange = (key, value) => {
    setLoading(true);
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleExport = async (format) => {
    // Simulate export functionality
    console.log(`Exporting analytics data in ${format} format...`);
    
    // Mock export process
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // In a real application, this would trigger file download
    const fileName = `brand-analytics-${new Date()?.toISOString()?.split('T')?.[0]}.${format}`;
    console.log(`Export completed: ${fileName}`);
    
    // Show success message (in real app, use toast notification)
    alert(`Analytics report exported successfully as ${fileName}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Breadcrumbs />
        
        <AnalyticsHeader 
          filters={filters}
          onFilterChange={handleFilterChange}
          onExport={handleExport}
        />

        <KPICards loading={loading} data={data.kpi} />

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
          <CostTrendChart loading={loading} data={data.costTrend} />
          <BrandPerformanceChart loading={loading} data={data.brandPerformance} />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
          <CostDistributionChart loading={loading} data={data.costDistribution} />
          <MultiStoreComparison loading={loading} data={data.multiStore} />
        </div>

        <DetailedAnalyticsTable loading={loading} data={data.detailedAnalytics} />
      </main>

      <QuickActionButton />
    </div>
  );
};

export default BrandAnalytics;